import Joi from 'joi-full';
import reduce from 'lodash/reduce';
import set from 'lodash/set';
import { isValidPhoneNumber } from 'react-phone-number-input';

export default function validateData(data = {}, schema = {}, options = {}) {
  return new Promise((resolve, reject) => {
    Joi.validate(
      data,
      schema,
      {
        ...options,
        abortEarly: false,
        allowUnknown: true,
        stripUnknown: { arrays: false, objects: false },
      },
      (err) => {
        if (err) {
          const errors = reduce(
            err.details,
            (result, singleError) => set(result, singleError.path, singleError.message),
            {}
          );
          return reject(errors);
        }
        return resolve();
      }
    );
  });
}

export const syncValidateData = (data = {}, schema = {}, options = {}) => {
  const validation = Joi.validate(data, schema, {
    ...options,
    abortEarly: false,
    allowUnknown: true,
    stripUnknown: { arrays: false, objects: false },
  });
  if (validation.error) {
    return reduce(
      validation.error.details,
      (result, singleError) => set(result, singleError.path, singleError.message),
      {}
    );
  }
  return true;
};

export const syncValidateDataJoiFresh = (data = {}, schema = {}, options = {}) => {
  const { error } = schema.validate(data, {
    ...options,
    abortEarly: false,
    allowUnknown: true,
    stripUnknown: { arrays: false, objects: false },
  });

  const reduxFormValidateErrors = {};

  if (error) {
    error.details.forEach((singleError) => {
      const errorKey = singleError.path[0];
      const errorMessage = singleError.message;

      // Groups errors for fields with array-like paths (e.g., "field.0") into single array,
      // and stores single-path field errors (e.g., "field") as strings.
      if (singleError.path.length > 1) {
        if (!Array.isArray(reduxFormValidateErrors[errorKey])) {
          reduxFormValidateErrors[errorKey] = [];
        }
        reduxFormValidateErrors[errorKey].push(errorMessage);
      } else if (!reduxFormValidateErrors[errorKey]) {
        reduxFormValidateErrors[errorKey] = errorMessage;
      }
    });
  }

  return reduxFormValidateErrors;
};

export const phoneErrorMessage = ' is not a valid phone number format.';

export const validatePhoneNumber = (value) => {
  if (value) {
    try {
      if (!isValidPhoneNumber(value)) {
        return phoneErrorMessage;
      }
    } catch (error) {
      return phoneErrorMessage;
    }
  }
  return null;
};

export const syncValidateDataWithPhone = (values, schema) => {
  const errors = {};
  const phoneError = validatePhoneNumber(values.phone);
  if (phoneError) {
    errors.phone = `Phone${phoneError}`;
  }
  const schemaErrors = syncValidateData(values, schema);
  return { ...errors, ...schemaErrors };
};
